@if (orderExceptions) {
  <div class="exceptions">
    <table>
      <thead>
        <tr>
          <th>Exception Details</th>
          <th>Created Date</th>
          <th>Current ETD</th>
          <th>Current ETA</th>
        </tr>
      </thead>
      @for (item of orderExceptions; track index; let index = $index; let last = $last) {
        <tbody>
          <tr>
            <td>{{ item.exceptionType }}</td>
            <td>{{ item.created | dateTimeFormat }}</td>
            <td>{{ item.requestedNewEtd | dateTimeFormat }}</td>
            <td>{{ item.requestedNewEta | dateTimeFormat }}</td>
          </tr>
          <tr>
            <td colspan="4">
              <app-order-exception-logs-table [logs]="item.logs"></app-order-exception-logs-table>
            </td>
          </tr>
        </tbody>
        @if (!last) {
          <td colspan="4">
            <mat-divider></mat-divider>
          </td>
        }
      } @empty {
        <tbody>
          <tr>
            <td colspan="6" class="exceptions__empty">No exceptions found</td>
          </tr>
        </tbody>
      }
    </table>
  </div>
} @else {
  <app-order-exception-table-skeleton></app-order-exception-table-skeleton>
}
